import Swiper, { Navigation, Pagination, Thumbs } from 'swiper';

Swiper.use([Navigation, Pagination, Thumbs]);

$(() => {
    const timelineYears = new Swiper('.timeline__years', {
        slidesPerView: 'auto',
    })

    const timeline = new Swiper('.timeline__slider', {
        slidesPerView: 1,
        spaceBetween: 10,
        loop: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        thumbs: {
            swiper: timelineYears,
        },
    })
});
